// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__uUdxK","modalContainer":"Modal_modalContainer__sXaAN","modalButtonClose":"Modal_modalButtonClose__n0-8r","iconClose":"Modal_iconClose__7oW9r"};